/**
 shave - Shave is a javascript plugin that truncates multi-line text within a html element based on set max height
 @version v2.5.2
 @link https://github.com/dollarshaveclub/shave#readme
 @author Jeff Wainwright <yowainwright@gmail.com> (jeffry.in)
 @license MIT
 **/
(function(global, factory) {
  'use strict';

  typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      (global.shave = factory());
}(this, (function() {
  'use strict';

  function shave(jQuery, target) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var elements = typeof target === 'string' ? document.querySelectorAll(target) : target;
    if (!elements) {
      return;
    }

    var character = opts.character || '…';
    var classname = opts.classname || 'js-shave';
    var classnameFullText = opts.classnameFulltext || 'js-shave-full-text';

    if (!('length' in elements)) {
      elements = [elements];
    }

    for (var i = 0; i < elements.length; i += 1) {
      var element = elements[i];
      var spanFullText = element.querySelector('.' + classnameFullText);
      var textProp = element.textContent === undefined ? 'innerText' : 'textContent';

      // If element text has already been shaved
      if (element.dataset.jsShaved === 'true') {
        element[textProp] = spanFullText[textProp];
      }

      var maxHeight = parseFloat(jQuery(element).css('max-height'));
      var styles = element.style;
      var fullText = element[textProp];

      // Temporarily remove any CSS height for text height calculation
      var heightStyle = styles.height;
      styles.height = 'auto';
      var maxHeightStyle = styles.maxHeight;
      styles.maxHeight = 'none';

      // If already short enough, we're done
      if (jQuery(element).height() <= maxHeight) {
        styles.height = heightStyle;
        styles.maxHeight = maxHeightStyle;
        element.dataset.jsShaved = "false";
        continue;
      }

      // Binary search for number of chars which can fit in allotted height
      var max = fullText.length - 1;
      var min = 0;
      var pivot = void 0;
      while (min < max) {
        pivot = min + max + 1 >> 1;
        element[textProp] = fullText.slice(0, pivot) + character;
        if (jQuery(element).height() > maxHeight) {
          max = pivot - 2;
        } else {
          min = pivot;
        }
      }

      element[textProp] = "";
      element.dataset.jsShaved = "true";
      element.insertAdjacentHTML('beforeend',
        '<span class="' + classname + '" >' + fullText.slice(0, max) + character + '</span>');
      styles.height = heightStyle;
      styles.maxHeight = maxHeightStyle;
    }
  }

  return shave;
})));
